import { atom } from 'jotai';
import type { TemplateEdgeT, TemplateNodeT } from '../../types/skeleton-template-builder.type';
export const templateNodesAtom = atom<TemplateNodeT[]>([]);
export const templateEdgesAtom = atom<TemplateEdgeT[]>([]);
export const selectedNodeIdAtom = atom<string | null>(null);
export const hoveredNodeIdAtom = atom<string | null>(null);